import {
  IGetSuggestedPayRatesByGigTypeParams,
  ISuggestedPayRates,
} from '@network/models/suggested-pay-rates.model'
import { AxiosService } from '@services'
import { Endpoints } from '@network/endpoints'
import { IPayload } from '@network/models/global.model'

export class SuggestedPayRatesApi {
  constructor(private axios: AxiosService) {}

  getSuggestedPayRatesByGigType = async (
    params: IGetSuggestedPayRatesByGigTypeParams,
  ) => {
    const response = await this.axios.get<IPayload<ISuggestedPayRates[]>>(
      Endpoints.getSuggestedPayRatesByGigType,
      params,
    )
    return response
  }
}
